import { AppRouteConfig, breadcrumbs } from '..';

export enum ReportsRouteName {
	report = 'Report',
	eventReports = 'EventReports',
}

export function reportsRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'event',
			name: ReportsRouteName.eventReports,
			component: () => import('../../views/report/EventReports.vue'),
			meta: {
				breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('eventReports')],
				caslSubject: 'reports.event_reports',
				caslAction: 'view',
				maskFeature: ['reports'],
			},
		},
	];
}
